export const groupFacets = (facets) =>
  facets.reduce((accum, facet) => {
    let grouped = accum;
    if (grouped[facet.group]) {
      grouped = {
        ...grouped,
        [facet.group]: [...grouped[facet.group], facet.value],
      };
    } else {
      grouped = {
        ...grouped,
        [facet.group]: [facet.value],
      };
    }
    return grouped;
  }, {});

const stringMatcher = (item, value, normalize) => {
  if (typeof normalize === 'function') {
    return normalize(item) === value;
  }
  return item === value;
};

const objectMatcher = (item, value, field, normalize) => {
  if (typeof normalize === 'function') {
    return normalize(item[field]) === value;
  }
  return item[field] === value;
};

const getType = (element) => {
  const elementAsObject = Object.prototype.toString.call(element);
  return elementAsObject.substr(8, elementAsObject.length - 8 - 1).toLowerCase();
};

export const createMatcher = (prop, value, normalize) => (item) => {
  const element = item[prop];
  switch (getType(element)) {
    case 'string':
      return stringMatcher(element, value, normalize);
    case 'object':
      return objectMatcher(element, value, 'id', normalize);
    default:
      return false;
  }
};

export const specificationFactory = {
  createOrSpec:
    (...matchers) =>
    (item) => {
      if (matchers.length) {
        return matchers.some((fn) => fn(item));
      }

      return true;
    },

  createAndSpec:
    (...matchers) =>
    (item) => {
      if (matchers.length) {
        return matchers.every((fn) => fn(item));
      }

      return true;
    },
};

export const filterBySpec = (items, spec) => items.filter(spec);
